import React from 'react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label?: string;
  className?: string;
  href?: string;
};
export function CtaButton({
  label = 'GET FLAG FOOTBALL READY NOW',
  className = '',
  href = CHECKOUT_URL
}: CtaButtonProps) {
  const isExternal = href.startsWith('http');
  return <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={`flex min-h-[60px] w-full items-center justify-center rounded-2xl bg-brand px-6 py-5 text-center font-display text-base font-extrabold uppercase tracking-tight text-ink shadow-brand transition-[box-shadow,background-color,transform] duration-150 ease-out-strong hover:-translate-y-0.5 hover:bg-brand-hover hover:shadow-brand-strong active:translate-y-0 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 sm:text-lg ${className}`} data-id="element-46" data-mp="cjr8bxn0jvr7">
      {label}
    </a>;
}